import { render } from "./CertificateDetail.vue?vue&type=template&id=05486e21"
import script from "./CertificateDetail.vue?vue&type=script&lang=js"
export * from "./CertificateDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__